import Login from './LoginContainer';
import ForgotPassword from './ForgotPasswordContainer';
import ActionResultPage from './ActionResultPage';
import ResetPassword from './ResetPasswordContainer';
import MFAVerification from './MFAVerification';
import MFARecoveryCode from './MFARecoveryCode';
import { handleLogoutRouteEnter } from './Auth.saga';
import { actionResultPageMessages as messages } from './Auth.messages';

export default [
  {
    path: '/login',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: Login,
  },
  {
    path: '/login/mfa',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: MFAVerification,
  },
  {
    path: '/login/mfa/recovery',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: MFARecoveryCode,
  },
  {
    path: '/logout',
    component: null,
    pathSagas: [handleLogoutRouteEnter],
  },
  {
    path: '/inactive-account',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: ActionResultPage,
    componentProps: {
      message: messages.userIsInactive,
    },
  },
  {
    path: '/reset-password/sent',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: ActionResultPage,
    componentProps: {
      message: messages.forgotPasswordSent,
    },
  },
  {
    path: '/reset-password/email-not-found',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: ActionResultPage,
    componentProps: {
      message: messages.userNotFound,
    },
  },
  {
    path: '/reset-password/:token',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: ResetPassword,
  },
  {
    path: '/reset-password',
    isPublic: true,
    redirectIfAuthenticated: true,
    component: ForgotPassword,
  },
];
